import { z } from 'zod'

export const trainerXanoUserExceptionResponseSchema = z.record(z.unknown())
export type TrainerXanoUserExceptionResponse = z.infer<typeof trainerXanoUserExceptionResponseSchema>
